import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { FluentTooltip } from "../../../../../../components/FluentUI/Fluent-Tooltip";

const FooterActions = ({ onCancel, onSave, isEditMode, canEdit = true }) => {
  const saveButton = (
    <Button 
      className="btn-wide" 
      type="submit" 
      onClick={onSave}
      disabled={isEditMode && !canEdit}
    >
      {isEditMode ? "Save" : "Create"}
    </Button>
  );

  return (
    <div className="float-right">
      <Button className="btn-wide btn-outlined" onClick={onCancel}>
        Cancel
      </Button>
      {isEditMode && !canEdit ? (
        <FluentTooltip
          positioning="above"
          text="You do not have the requisite Role Privileges to Edit Workflow Objects on TRIYO."
          target={saveButton}
        />
      ) : (
        saveButton
      )}
    </div>
  );
};

FooterActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
};

export default FooterActions;
